import * as React from 'react';

import PublicRouter from './PublicRouter';
import PrivateRouter from './PrivateRouter';

import { connect } from 'react-redux';

import { ScrollToTop } from './Container';
import { IsAuthentificatedState } from 'loopback-react-request';
import { Dispatch } from 'redux';
import { Redirect } from 'react-router';

interface DefaultRouterProps {
  authenticator: IsAuthentificatedState;
  dispatch: Dispatch;
}

interface DefaultRouterState {
  //wasAuthenticated: boolean;
  isAuthentificated: IsAuthentificatedState['isAuthentificated'];
}

class DefaultRouter extends React.Component<DefaultRouterProps, DefaultRouterState> {
  constructor(props: DefaultRouterProps) {
    super(props);
    this.state = {
      //wasAuthenticated: false,
      isAuthentificated: props.authenticator.isAuthentificated
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: DefaultRouterProps) {
    this.setState({
      //wasAuthenticated: this.props.authenticator.isAuthentificated && !nextProps.authenticator.isAuthentificated,
      isAuthentificated: nextProps.authenticator.isAuthentificated
    });
  }

  public render() {
    const { isAuthentificated } = this.state;
    return (
      <ScrollToTop>
        <>
          {isAuthentificated && (
            <PrivateRouter />
          )}
          {!isAuthentificated && (
            <PublicRouter />
          )}
        </>
      </ScrollToTop>
    );
  }
}

export default connect((state: any) => ({
  authenticator: state.authenticator,
}))(DefaultRouter);
